import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  getFlagImagePath,
  getFlagImagePathFromCode,
  getTeamCodeFromName,
} from "utils/getFlagImagePath";

export default function TeamFlagImage({
  teamName,
  teamCode,
  className,
  placeholderClassName,
}) {
  const [hasError, setHasError] = useState(false);
  const flagSrc = useMemo(
    () =>
      teamCode
        ? getFlagImagePathFromCode(teamCode)
        : getFlagImagePath(teamName),
    [teamCode, teamName]
  );
  const resolvedTeamCode = useMemo(
    () => teamCode || getTeamCodeFromName(teamName),
    [teamCode, teamName]
  );

  useEffect(() => {
    setHasError(false);
  }, [teamCode, teamName, flagSrc]);

  if (!flagSrc || hasError) {
    const placeholderClasses = [
      "TeamFlagPlaceholder",
      placeholderClassName,
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={placeholderClasses} aria-hidden="true">
        {resolvedTeamCode ? resolvedTeamCode.toUpperCase() : ""}
      </div>
    );
  }

  const isSmallFlag =
    placeholderClassName?.includes("small") ||
    className?.includes("FlagSmallIcon");

  return (
    <img
      className={className}
      src={flagSrc}
      alt=""
      width={isSmallFlag ? 24 : undefined}
      height={isSmallFlag ? 16 : undefined}
      style={{ objectFit: "cover", flexShrink: 0 }}
      onError={() => setHasError(true)}
    />
  );
}

TeamFlagImage.propTypes = {
  teamName: PropTypes.string,
  teamCode: PropTypes.string,
  className: PropTypes.string,
  placeholderClassName: PropTypes.string,
};

TeamFlagImage.defaultProps = {
  teamName: "",
  teamCode: "",
  className: "",
  placeholderClassName: "",
};
